import { useOnlineStatus } from '../../hooks/useOnlineStatus.js';
import { cn } from '../../lib/utils.js';

export const OfflineBanner = () => {
  const online = useOnlineStatus();

  return (
    <div
      className={cn(
        'fixed top-0 left-0 right-0 z-50 max-w-[430px] mx-auto',
        'flex items-center justify-center gap-2',
        'text-xs font-bold py-2 transition-all duration-300',
        online ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      )}
      style={{ background: '#FF6B6B', color: '#fff', paddingTop: 'calc(env(safe-area-inset-top, 0px) + 8px)' }}
    >
      <span>📡</span>
      Offline — changes will sync when reconnected
    </div>
  );
};
